import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';

import SeeAll from '../SeeAll/SeeAll';
import HomeSlider from '../HomeSlider/HomeSlider';
import Shimmer from "../../Skeleton/Shimmer";
import HomeSliderSkleton from "../../Skeleton/HomeSliderSkleton";

import { getMostViewedListingQuery } from '../../../lib/graphql';
import messages from '../../../locale/jsonMessages';
import { withQuery } from '../../../hoc/withGraphql';

import s from './MostViewedListing.css';
import l from '../../Skeleton/Skeleton.css';

function MostViewedListing({ getMostViewedListingData }) {

  const { loading, GetMostViewedListing } = getMostViewedListingData || {};

  if (loading) {
    return (
      <div className={s.pageContainer}>
        <div className={s.container}>
          <div className={cx(l.popularSkeletonTitle)}>
            <Shimmer />
          </div>
          <div className='fourCardSkeleton'>
            {[1, 2, 3, 4].map((n) => (
              <HomeSliderSkleton key={n} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {GetMostViewedListing?.length > 0 && (
        <div className={s.container}>
          <div className={s.pageContainer}>
            <h3 className={s.containerTitle}>
              <FormattedMessage {...messages.mostViewed} />
            </h3>
            <HomeSlider data={GetMostViewedListing} paginationNextClass="mostReviewSwiperNavigationNextBtn" paginationPrevClass="mostReviewSwiperNavigationPrevBtn" />
            <SeeAll />
          </div>
        </div>
      )}
    </>
  );
}

MostViewedListing.propTypes = {
  getMostViewedListingData: PropTypes.shape({
    loading: PropTypes.bool,
    GetMostViewedListing: PropTypes.array
  })
};

MostViewedListing.defaultProps = {
  getMostViewedListingData: {
    loading: true
  }
};

export default compose(
  injectIntl,
  withStyles(s, l),
  withQuery(getMostViewedListingQuery, {
    name: 'getMostViewedListingData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(MostViewedListing);
